import { z } from 'zod';

import { Option } from '../../types/Option';

// As per IEC 60947-10

export const openingTime = ['ultra-fast', 'fast', 'conventional'] as const;

export type OpeningTime = (typeof openingTime)[number];

const options: Option<OpeningTime>[] = [
    { value: 'ultra-fast', label: 'Ultra-fast (less than 10 µs)' },
    { value: 'fast', label: 'Fast (less than 1 ms)' },
    { value: 'conventional', label: 'Conventional (more than 1 ms)' },
];

const validator = z
    .enum(openingTime)
    .default('conventional')
    .catch(() => 'conventional' as OpeningTime);

export const OpeningTime = {
    validator,
    options,
};
